
import { UserCache } from "../../caches";
import { BaseClientService } from "../base-client.service";
import { ControllerOptions, DataController } from "../../../types";
import { AppUser, UserSession, UserSessionService, UserService } from "@nt-portal/server-sdk";
import { FetchParams } from "@nt-portal/common-sdk";

export interface UserSessionOptions extends ControllerOptions<UserSession> {

}


export class ClientUserSessionService extends BaseClientService implements DataController<UserSession> {

    private _service: UserSessionService;

    constructor() {
        super();
        this._service = new UserSessionService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }


    public async get(options: UserSessionOptions) {
        let fetchParams = this.buildFetchParams(options)
        let sessions = await this._service.get(fetchParams, this.token);
        return sessions;


    }




}